// extracted by mini-css-extract-plugin
export default {"mainCover":"input_mainCover__WRK09","label":"input_label__jACnX","inputCover":"input_inputCover__PxyHI"};